'use strict';

/**
 * @ngdoc directive
 * @name thothApp.directives:scopeChangeHistory
 * @description
 * # scopeChangeHistory
 * Historial de solicitudes de cambio de alcance de un proyecto origen. Sigue el
 * diseno del documento: linea de tiempo, una tarjeta por solicitud y las
 * acciones de revision dentro de la tarjeta.
 */
angular.module('thothApp.directives')
  .directive('scopeChangeHistory', function() {
    return {
      restrict: 'E',
      scope: { projectId: '=' },
      templateUrl: 'views/scope_changes/history.html',
      controller: ['$scope', '$window', 'ScopeChangeRequest', 'ScopeChangeReview', 'toaster',
        function($scope, $window, ScopeChangeRequest, ScopeChangeReview, toaster) {
          $scope.loading = true;
          $scope.requests = [];
          $scope.selected = null;
          $scope.reviewing = null;

          if ('apiUser' in $window.localStorage) {
            $scope.canReview = JSON.parse($window.localStorage.apiUser).project_management_role === true;
          }

          $scope.load = function() {
            if (!$scope.projectId) { return; }
            $scope.loading = true;

            ScopeChangeRequest.index({ params: {
              origin_project_id: $scope.projectId, per_page: 'all'
            }}).then(function(response) {
              $scope.requests = response.data.scope_change_requests;
              $scope.selected = $scope.requests[0] || null;
              $scope.loading = false;
            }, function(error) {
              $scope.loading = false;
              ScopeChangeRequest.error(error);
            });
          };

          $scope.select = function(request) {
            $scope.selected = request;
          };

          $scope.isSelected = function(request) {
            return $scope.selected && $scope.selected.id === request.id;
          };

          // El documento muestra el peso junto al tipo de archivo. Las
          // solicitudes anteriores a esta pantalla no lo tienen guardado.
          $scope.formatSize = function(bytes) {
            if (!bytes) { return ''; }
            var kb = bytes / 1024;
            return kb < 1024 ? Math.round(kb) + ' KB' : (kb / 1024).toFixed(1) + ' MB';
          };

          function review(request, action, mensaje) {
            $scope.reviewing = request.id;

            ScopeChangeReview[action](request).then(function() {
              toaster.pop('success', 'Solicitud', mensaje);
              $scope.reviewing = null;
              $scope.load();
            }).catch(function(error) {
              $scope.reviewing = null;
              ScopeChangeReview.report(error, toaster);
              $scope.load();
            });
          }

          $scope.approve = function(request) {
            review(request, 'approve', 'La solicitud se aprobó y el proyecto quedó creado');
          };

          $scope.reject = function(request) {
            review(request, 'reject', 'La solicitud se rechazó correctamente');
          };

          $scope.$watch('projectId', function(value) {
            if (value) { $scope.load(); }
          });
        }]
    };
  });
